import { render } from "./WorkflowCard.vue?vue&type=template&id=d630a394&scoped=true"
import script from "./WorkflowCard.vue?vue&type=script&lang=js"
export * from "./WorkflowCard.vue?vue&type=script&lang=js"

import "./WorkflowCard.vue?vue&type=style&index=0&id=d630a394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d630a394"]])

export default __exports__